document.addEventListener('DOMContentLoaded', function () {
	// Verificar si el body tiene la clase specialReportsV2
	if (document.body.classList.contains('specialReportsV2')) {
			// Hamburger Menu
			if (document.querySelector('.sr-hamburger')) { 
					const srhamburgerButton = document.querySelector(".sr-hamburger");
					const srhamburgerMenuText = document.querySelector(".sr-menuText");
					const srhamburgerMenu = document.querySelector(".sreports-menuItems");
					
					srhamburgerButton.onclick = function() {
							this.classList.toggle("is-active");
							srhamburgerMenuText.classList.toggle("hideTextMenu");
							srhamburgerMenu.classList.toggle("show-menu");
					};
			}
	}
});
